import { MODAL_Z_INDEX } from '../modal/modal.style';
import { DefaultTheme } from '../theme';

export const CSS = {
	backdrop: 'c-AnchoredPopover__backdrop',
	panel: 'c-AnchoredPopover__panel',
	header: 'c-AnchoredPopover__header',
	title: 'c-AnchoredPopover__title',
	titleFixed: 'c-AnchoredPopover__titleFixed',
	titleName: 'c-AnchoredPopover__titleName',
	close: 'c-AnchoredPopover__close',
	body: 'c-AnchoredPopover__body',
};

export const BACKDROP_Z_INDEX = MODAL_Z_INDEX + 1;
export const PANEL_Z_INDEX = MODAL_Z_INDEX + 2;

export const Style = {
	[CSS.backdrop]: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		'z-index': BACKDROP_Z_INDEX,
		background: 'transparent',
	},
	[CSS.panel]: {
		// position / top / left / width / max-height / visibility are set inline from the placement.
		display: 'flex',
		'flex-direction': 'column',
		overflow: 'hidden',
		background: DefaultTheme.background.offWhite,
		'border-radius': '10px',
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'box-shadow': DefaultTheme.shadow.box.dp6,
	},
	[CSS.header]: {
		flex: '0 0 auto',
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(1),
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.title]: {
		flex: '1 1 auto',
		'min-width': 0,
		display: 'flex',
		'font-weight': 'bold',
		color: DefaultTheme.font.color.primary,
	},
	// Fixed wrapping words ("Customize" / "symbol") stay pinned; only the line-type name shrinks.
	[CSS.titleFixed]: {
		flex: '0 0 auto',
		'white-space': 'pre',
	},
	[CSS.titleName]: {
		flex: '0 1 auto',
		'min-width': 0,
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
	},
	[CSS.close]: {
		flex: '0 0 auto',
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		border: 'none',
		background: 'none',
		cursor: 'pointer',
		'border-radius': '4px',
		padding: DefaultTheme.space(1),
		color: DefaultTheme.font.color.supporting,
	},
	[`${CSS.close}:hover`]: {
		background: DefaultTheme.background.lightGrey,
	},
	[CSS.body]: {
		flex: '1 1 auto',
		'min-height': 0,
		'overflow-y': 'auto',
		padding: DefaultTheme.space(3),
	},
};
